import { SecurePassAutoSend } from "@/utils/enum";
import { logout } from "@/utils/session";
import { getSessionStorage, setSessionStorage } from "@/utils/storage";
import { getLocalStorage } from "@/utils/storage";
import { validateFeature } from "@/services/feature";
import { refreshToken } from "@/services/login";
import { getAppConfigData } from "@/services/user";

const ConfigsModel = {
  namespace: "configs",
  state: {
    configLang: {},
    configCurrentUser: {},
    configPerm: {},
    configMaintenanceMode: false,
    configFetched: false,
    devModeBypass: getSessionStorage("devModeBypass") || false,
    securePass: {},
  },
  effects: {
    *getConfigData(_, { call, put }) {
      let conf = yield call(getAppConfigData);

      if (Object.keys(conf.auth.grantedPolicies).length === 0 && getLocalStorage("dataAuth") !== null) {
        // Try to refresh token
        yield call(refreshToken);
        conf = yield call(getAppConfigData);
      }

      if (Object.keys(conf.auth.grantedPolicies).length === 0) {
        // Nothing to do, logout
        yield put({ type: "updateLang", payload: {} });
        yield put({ type: "updateCurrentUser", payload: {} });
        yield put({ type: "updatePerm", payload: {} });
        yield put({ type: "updateMaintenanceMode", payload: {} });
        yield put({ type: "updateFetched", payload: false });
        yield call(logout);
      }

      yield put({
        type: "updateLang",
        payload: conf.localization.values,
      });

      yield put({
        type: "updateCurrentUser",
        payload: conf.currentUser,
      });

      yield put({
        type: "updatePerm",
        payload: conf.auth.grantedPolicies,
      });

      yield put({
        type: "updateMaintenanceMode",
        payload: conf?.features?.values?.["MaintenanceMode.Enabled"] === "true",
      });

      yield put({
        type: "updateFetched",
        payload: true,
      });

      const securePassAutoSend = Number(conf?.features?.values?.["SecurePass.AutosendType"]);
      const securePassTreshold = Number(conf?.features?.values?.["SecurePass.VehicleMSRPThreshold"]);

      yield put({
        type: "updateSecurePass",
        payload: {
          enabled: securePassAutoSend !== SecurePassAutoSend.NOT_SEND,
          autoSend: securePassAutoSend,
          treshold: securePassTreshold,
        },
      });
    },
    *validateDevKey({ payload }, { call, put }) {
      try {
        const isValid = yield call(validateFeature, payload);

        yield put({
          type: "updateDevModeBypass",
          payload: isValid,
        });

        return { error: !isValid };
      } catch (error) {
        yield put({
          type: "updateDevModeBypass",
          payload: false,
        });
        return { error: true };
      }
    },
  },
  reducers: {
    updateLang(state, action) {
      return { ...state, configLang: action.payload };
    },
    updateCurrentUser(state, action) {
      return { ...state, configCurrentUser: action.payload };
    },
    updatePerm(state, action) {
      return { ...state, configPerm: action.payload };
    },
    updateMaintenanceMode(state, action) {
      return { ...state, configMaintenanceMode: action.payload };
    },
    updateFetched(state, action) {
      return { ...state, configFetched: action.payload };
    },
    updateDevModeBypass(state, action) {
      // only save to session storage if it's true
      if (action.payload) {
        setSessionStorage("devModeBypass", action.payload);
      }

      return { ...state, devModeBypass: action.payload };
    },
    updateSecurePass(state, action) {
      return { ...state, securePass: action.payload };
    },
  },
};
export default ConfigsModel;
